import debug from 'debug'

const trace = debug('vuex:alert')

const state = () => ({
  message: '',
  show: false,
  type: 'alert'
})

const DEFAULT_ERROR_MESSAGE = '系統內部發生罷工，請聯繫系統管理員'

const ERROR_MESSAGES = {
  0: '網路連線有點問題，請稍候再試',
  401: '您可能登入憑證失效，請嘗試重新登入，若問題無法解決請聯繫系統管理員',
  403: '您可能沒有足夠的權限進行此操作，請聯繫系統管理員為您開啟權限',
  404: '我們找不到指定的資源',
  422: '您送出的資料可能不正確，請嘗試修正欄位內容的格式，例如文字長度、網址格式、Email 格式等',
  500: '艾倫寫了個 bug，你遇到了那個 bug，請聯繫系統管理員',
  504: '您送出的請求伺服器沒有回應，連線時間過久因此逾時，請聯繫系統管理員'
}

const actions = {
  set({ commit }, { text, code, type, error }) {
    if (error) {
      text = error.message
    }
    // default type is danger
    type = type || 'danger'
    const msg = text || ERROR_MESSAGES[code] || DEFAULT_ERROR_MESSAGE
    trace('actions: setAlert', { msg, type })
    commit('SET', { msg, type })
  },

  remove({ commit }) {
    commit('REMOVE')
  },

  clear({ dispatch }) {
    return dispatch('remove')
  }
}

const mutations = {
  SET(state, { msg, type }) {
    trace('mutations: SET', { msg, type })
    state.show = true
    state.message = msg
    state.type = type || state.type
  },

  REMOVE(_state) {
    const init = state()
    Object.keys(init).forEach(key => {
      _state[key] = init[key]
    })
  }
}

export default {
  namespaced: true,
  state: state(),
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/alert.js